// extracted by mini-css-extract-plugin
export default {"href":"PageError_href__1tsbT"};